import React from "react"
export function Camera(props) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <path
        d="M12.8 2l1.708 1.786h1.625c.976 0 1.783.726 1.86 1.64l.007.147v9.39c0 .934-.758 1.706-1.714 1.781l-.153.006H3.867c-.976 0-1.783-.725-1.86-1.64L2 14.964V5.573c0-.934.758-1.706 1.714-1.78l.153-.007h1.625L7.2 2h5.6zM10 5.706c-2.392 0-4.333 1.95-4.333 4.354 0 2.403 1.941 4.354 4.333 4.354 2.392 0 4.333-1.95 4.333-4.354 0-2.403-1.941-4.354-4.333-4.354zm0 1.696c1.473 0 2.667 1.2 2.667 2.679 0 1.48-1.194 2.68-2.667 2.68a2.673 2.673 0 01-2.667-2.68c0-1.48 1.194-2.68 2.667-2.68z"
        fill="currentColor"
        id="prefix__camera"
        stroke="none"
        strokeWidth={1}
        fillRule="evenodd"
      />
    </svg>
  )
}
